import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ActiveAntsWarehouseCheckInService } from "src/services";
import { QueryParamsMapper } from "src/mappers";
import { queryKeys } from "src/constants";
import { DateTimeRange, WarehouseCheckInsPaginationOptions, WarehouseCheckInsFilters } from "src/types";

export const useActiveAntsWarehouseCheckIns = (
  activeAntsWarehouseCheckInService: ActiveAntsWarehouseCheckInService,
  dateTimeRange?: DateTimeRange,
  filter?: WarehouseCheckInsFilters,
  paginationOptions?: WarehouseCheckInsPaginationOptions
) => {
  const queryClient = useQueryClient();

  const queryParams = QueryParamsMapper.getWarehouseCheckInsQueryParams(dateTimeRange, filter, paginationOptions);

  const {
    data: paginatedActiveAntsWarehouseCheckIns,
    error: fetchError,
    isLoading
  } = useQuery({
    queryKey: queryKeys.paginatedActiveAntsWarehouseCheckIns(queryParams),
    queryFn: () => activeAntsWarehouseCheckInService.getActiveAntsWarehouseCheckIns(queryParams)
  });

  const refreshActiveAntsWarehouseCheckIns = () => {
    queryClient.removeQueries({
      queryKey: queryKeys.paginatedActiveAntsWarehouseCheckIns(),
      exact: false
    });
  };

  return { paginatedActiveAntsWarehouseCheckIns, fetchError, isLoading, refreshActiveAntsWarehouseCheckIns };
};
